module.exports = __webpack_public_path__ + "img/parte_2.6cf9cb8d.svg";